/**
 * 角色显示配置文件
 * 集中管理角色画像显示相关的所有配置，避免硬代码
 */

// ==================== 性别配置 ====================
export const GENDER_CONFIG = {
  // 性别关键词（用于识别）
  FEMALE_KEYWORDS: ['女', 'female', '女性', 'f'],
  MALE_KEYWORDS: ['男', 'male', '男性', 'm'],
  
  // 性别显示
  DISPLAY: {
    FEMALE: '女',
    MALE: '男'
  },
  
  // 性别颜色
  COLORS: {
    FEMALE: 'rgba(255, 105, 180, 0.9)',
    MALE: 'rgba(30, 144, 255, 0.9)',
    DEFAULT: 'rgba(255, 255, 255, 0.3)'
  }
};

// ==================== 角色类型配置 ====================
export const ROLE_CONFIG = {
  // 角色类型值
  TYPES: {
    PROTAGONIST: 'protagonist',
    ANTAGONIST: 'antagonist',
    SUPPORTING: 'supporting'
  },

  // 角色类型显示
  DISPLAY: {
    protagonist: '主角',
    antagonist: '反派',
    supporting: '配角'
  },

  // 角色类型颜色
  COLORS: {
    protagonist: '#ffd700',
    antagonist: '#ef4444',
    supporting: '#a78bfa'
  },

  // 角色类型边框样式
  BORDER_STYLE: {
    protagonist: { width: '4px', style: 'solid' },
    antagonist: { width: '4px', style: 'solid' },
    supporting: { width: '3px', style: 'solid' }
  }
};

// ==================== 辅助函数 ====================

/**
 * 根据性别值获取对应的颜色
 * @param {string} gender - 性别值
 * @returns {string} 颜色值
 */
export const getGenderColor = (gender) => {
  if (!gender) return GENDER_CONFIG.COLORS.DEFAULT;
  
  const genderLower = gender.toLowerCase();
  
  if (GENDER_CONFIG.FEMALE_KEYWORDS.some(keyword => genderLower.includes(keyword))) {
    return GENDER_CONFIG.COLORS.FEMALE;
  }
  
  if (GENDER_CONFIG.MALE_KEYWORDS.some(keyword => genderLower.includes(keyword))) {
    return GENDER_CONFIG.COLORS.MALE;
  }
  
  return GENDER_CONFIG.COLORS.DEFAULT;
};

/**
 * 根据性别值获取显示文本
 * @param {string} gender - 性别值
 * @returns {string} 显示文本
 */
export const getGenderDisplay = (gender) => {
  if (!gender) return gender;
  
  const genderLower = gender.toLowerCase();
  
  if (GENDER_CONFIG.FEMALE_KEYWORDS.some(keyword => genderLower.includes(keyword))) {
    return GENDER_CONFIG.DISPLAY.FEMALE;
  }
  
  if (GENDER_CONFIG.MALE_KEYWORDS.some(keyword => genderLower.includes(keyword))) {
    return GENDER_CONFIG.DISPLAY.MALE;
  }
  
  return gender;
};

/**
 * 根据角色类型获取对应的颜色
 * @param {string} role - 角色类型
 * @returns {string} 颜色值
 */
export const getRoleColor = (role) => {
  return ROLE_CONFIG.COLORS[role] || ROLE_CONFIG.COLORS.supporting;
};

/**
 * 根据角色类型获取显示文本
 * @param {string} role - 角色类型
 * @returns {string} 显示文本
 */
export const getRoleDisplay = (role) => {
  return ROLE_CONFIG.DISPLAY[role] || ROLE_CONFIG.DISPLAY.supporting;
};

// ==================== 样式配置 ====================
export const CHARACTER_BADGE_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  px: 1.5,
  py: 0.5,
  borderRadius: '12px',
  border: '2px solid white',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
};

export const CHARACTER_BADGE_TEXT_STYLE = {
  fontWeight: 'bold',
  color: 'white',
  fontSize: '0.85rem'
};

